module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-img-02-b88a81ae959932faaaf9022ab9909b6c.jpg";